import gsap from "gsap/all";
import throttle from "lodash.throttle";

export default () => ({
  newsTickers: document.querySelectorAll(".ticker"),
  tl: null,

  init() {
    this.initInfiniteSlider();
  },

  initInfiniteSlider() {
    const inBackend = document.body.classList.contains("neos-backend");

    if (inBackend) return;

    this.newsTickers.forEach((ticker) => {
      const slides = ticker.querySelectorAll(".slide");

      gsap.set(slides, { xPercent: -100 });

      const previousHeight = window.innerHeight;
      let sliderSpeed = window.innerWidth >= 768 ? 30 : 24; // seconds
      let slideWidth = slides[0].clientWidth;
      let totalWidth =
        slides.length > 2
          ? slideWidth * slides.length
          : slideWidth * slides.length * 1.1; // * n of slides
      let dirFromRight = "-=" + totalWidth;
      let mod = gsap.utils.wrap(0, totalWidth);

      // set offset for each slide
      this.setSlidesOffset(slides, slideWidth);

      // slide into view animation
      this.tl = gsap.timeline().to(slides, {
        x: dirFromRight,
        modifiers: {
          x: (x) => mod(parseFloat(x)) + "px",
        },
        duration: sliderSpeed,
        delay: 3.5,
        ease: "none",
        repeat: -1,
      });

      this.registerHoverEvent(ticker);

      // responsiveness - recalculate on window resize event
      window.addEventListener(
        "resize",
        throttle(() => {
          if (window.innerHeight !== previousHeight) return;

          this.tl.kill();

          sliderSpeed = window.innerWidth >= 768 ? 30 : 20;
          slideWidth = slides[0].clientWidth;
          totalWidth = slideWidth * slides.length;
          dirFromRight = "-=" + totalWidth;
          mod = gsap.utils.wrap(0, totalWidth);

          this.setSlidesOffset(slides, slideWidth);

          this.tl = gsap.timeline().to(slides, {
            x: dirFromRight,
            modifiers: {
              x: (x) => mod(parseFloat(x)) + "px",
            },
            duration: sliderSpeed,
            ease: "none",
            repeat: -1,
          });

          this.registerHoverEvent(ticker);
        }, 250)
      );
    });
  },

  registerHoverEvent(ticker) {
    // prevent hover event when NOT touch device
    if ("ontouchstart" in document.documentElement) return;

    ticker.addEventListener("mouseenter", () => {
      this.tl.pause();
    });

    ticker.addEventListener("mouseleave", () => {
      this.tl.resume();
    });
  },

  setSlidesOffset(slides, slideWidth) {
    gsap.set(slides, {
      x: function (i) {
        return i * slideWidth;
      },
    });
  },
});
